var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "authorization w1200" },
    [
      _vm.isOpenType == 0
        ? _c("p", { staticClass: "f20 fb mar20-b" }, [
            _vm._v("授权并发布小程序")
          ])
        : _vm._e(),
      _vm.isOpenType == 1
        ? _c("p", { staticClass: "f20 fb mar20-b" }, [
            _vm._v("创建并发布小程序")
          ])
        : _vm._e(),
      _c(
        "el-steps",
        { attrs: { direction: "vertical", active: _vm.active } },
        [
          _vm.isOpenType == 1
            ? [
                _c(
                  "el-step",
                  { staticClass: "f16", attrs: { title: "快速创建小程序" } },
                  [
                    _c("template", { slot: "description" }, [
                      _c("div", { staticClass: "mar30-b flex items-center" }, [
                        _c("div", { staticClass: "pad50-r flex1" }, [
                          _c("p", { staticClass: "gray9 f12 mar10-t" }, [
                            _vm._v("\n                填写"),
                            _c("span", { staticClass: "red" }, [
                              _vm._v("法人实名认证过的微信号")
                            ]),
                            _vm._v(",填写"),
                            _c("span", { staticClass: "red" }, [
                              _vm._v("工商信息")
                            ]),
                            _vm._v("， 引导"),
                            _c("span", { staticClass: "red" }, [
                              _vm._v("法人扫脸完成认证")
                            ]),
                            _vm._v(
                              "，认证成功后， 完善小程序名称、头像基本信息即可获得一个正式在微信内可搜索的小程序。\n              "
                            )
                          ]),
                          _c(
                            "a",
                            {
                              staticClass: "blue f12 mar10-t",
                              attrs: {
                                href: "https://znt.com.cn/postdetail?id=918946",
                                target: "_blank"
                              }
                            },
                            [_vm._v("法人操作教程")]
                          )
                        ]),
                        _c(
                          "div",
                          [
                            _vm.appletInfo == null ||
                            _vm.appletInfo.appId == "" ||
                            (_vm.appletInfo && _vm.appletInfo.regStatus == 1)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.regVisible = true
                                      }
                                    }
                                  },
                                  [_vm._v("立即创建")]
                                )
                              : _vm._e(),
                            _vm.appletInfo &&
                            _vm.appletInfo.appId != "" &&
                            _vm.appletInfo.regStatus == 2
                              ? _c("div", { staticClass: "f16" }, [
                                  _c("i", {
                                    staticClass: "el-icon-success mar5-r green"
                                  }),
                                  _c("span", { staticClass: "blue f14" }, [
                                    _vm._v("创建成功")
                                  ])
                                ])
                              : _vm._e(),
                            _vm.appletInfo &&
                            _vm.appletInfo.appId != "" &&
                            _vm.appletInfo.regStatus == 3
                              ? _c("div", { staticClass: "f16" }, [
                                  _c("i", {
                                    staticClass: "el-icon-warning mar5-r gray9"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "red f14 mar5-r" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.appletInfo.thirdPartyRegMsg)
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "blue f14 flex1 pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.regVisible = true
                                        }
                                      }
                                    },
                                    [_vm._v("修改")]
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  2
                ),
                _c(
                  "el-step",
                  { staticClass: "f16", attrs: { title: "设置小程序信息" } },
                  [
                    _c("template", { slot: "description" }, [
                      _c("div", { staticClass: "mar30-b flex items-center" }, [
                        _c("div", { staticClass: "pad50-r flex1" }, [
                          _c("p", { staticClass: "gray9 f12 mar10-t" }, [
                            _vm._v(
                              "设置小程序基本信息，生成体验版小程序，查看效果"
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          [
                            _vm.appletInfo == null ||
                            _vm.appletInfo.appId == "" ||
                            (_vm.appletInfo &&
                              _vm.appletInfo.auditStatus == 0 &&
                              _vm.appletInfo.isReg)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled:
                                        _vm.appletInfo == null ||
                                        _vm.appletInfo.appId == "" ||
                                        (_vm.appletInfo &&
                                          _vm.appletInfo.regStatus != 2)
                                    },
                                    on: { click: _vm.openSetVisible }
                                  },
                                  [_vm._v("立即设置")]
                                )
                              : _vm._e(),
                            _vm.appletInfo &&
                            _vm.appletInfo.isReg &&
                            (_vm.appletInfo.auditStatus == 1 ||
                              _vm.appletInfo.auditStatus == 2 ||
                              _vm.appletInfo.auditStatus == 3)
                              ? _c(
                                  "div",
                                  { staticClass: "f16" },
                                  [
                                    _vm.appletInfo.auditStatus == 3
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-success mar5-r green"
                                        })
                                      : _vm._e(),
                                    _vm.appletInfo.auditStatus == 3
                                      ? _c(
                                          "span",
                                          { staticClass: "mar5-r blue f14" },
                                          [_vm._v("设置成功")]
                                        )
                                      : _vm._e(),
                                    _vm.appletInfo.auditStatus == 1
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-warning mar5-r gray9"
                                        })
                                      : _vm._e(),
                                    _vm.appletInfo.auditStatus == 1
                                      ? _c("span", { staticClass: "mar5-r" }, [
                                          _vm._v("立即设置")
                                        ])
                                      : _vm._e(),
                                    _vm.appletInfo &&
                                    _vm.appletInfo.isReg &&
                                    _vm.appletInfo.auditStatus == 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "blue f14 flex1 pointer",
                                            on: { click: _vm.openSetVisible }
                                          },
                                          [_vm._v("修改")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mar20-l",
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.appletInfo == null ||
                                            _vm.appletInfo.appId == ""
                                        },
                                        on: { click: _vm.getTestQrcodeUrl }
                                      },
                                      [_vm._v("\n                  获取体验版")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  2
                ),
                _c(
                  "el-step",
                  {
                    staticClass: "f16",
                    attrs: { title: "完成所有准备，提交审核并发布小程序" }
                  },
                  [
                    _c("template", { slot: "description" }, [
                      _c("div", { staticClass: "mar30-b flex items-center" }, [
                        _c("div", { staticClass: "pad50-r flex1" }, [
                          _c("p", { staticClass: "gray9 f12 mar10-t" }, [
                            _vm._v(
                              "提交微信审核（最长14个工作日），审核通过后即可立即发布版本"
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          [
                            _vm.appletInfo == null ||
                            _vm.appletInfo.appId == "" ||
                            (_vm.appletInfo &&
                              _vm.appletInfo.isReg &&
                              _vm.appletInfo.isRelease == 0 &&
                              _vm.appletInfo.auditStatus == 1)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled:
                                        _vm.appletInfo == null ||
                                        _vm.appletInfo.appId == "" ||
                                        (_vm.appletInfo &&
                                          _vm.appletInfo.auditStatus != 1)
                                    },
                                    on: { click: _vm.getSubmit }
                                  },
                                  [_vm._v("提交审核")]
                                )
                              : _vm._e(),
                            _vm.appletInfo &&
                            _vm.appletInfo.isReg &&
                            _vm.appletInfo.isRelease == 0 &&
                            _vm.appletInfo.regStatus == 2 &&
                            _vm.appletInfo.auditStatus == 2
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", disabled: true },
                                    on: { click: _vm.getSubmit }
                                  },
                                  [_vm._v("审核中")]
                                )
                              : _vm._e(),
                            _vm.appletInfo &&
                            _vm.appletInfo.isReg &&
                            _vm.appletInfo.isRelease == 1
                              ? _c("div", { staticClass: "f16" }, [
                                  _c("i", {
                                    staticClass: "el-icon-success mar5-r green"
                                  }),
                                  _c("span", [_vm._v("发布成功")])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm.isOpenType == 0
            ? [
                _c(
                  "el-step",
                  {
                    staticClass: "f16",
                    attrs: { title: "已注册微信小程序，立即授权发布" }
                  },
                  [
                    _c("template", { slot: "description" }, [
                      _c("div", { staticClass: "mar30-b flex items-center" }, [
                        _c("div", { staticClass: "pad50-r flex1" }, [
                          _c("p", { staticClass: "gray9 f12 mar10-t" }, [
                            _vm._v(
                              "\n                使用微信小程序管理员帐号扫码进行授权，授权过程中请勾选所有权限以确保小程序功能完整性。如未注册小程序，可以从公众号后台免微信认证创建小程序或直接前往“微信公众平台”注册企业主体的小程序帐号。\n              "
                            )
                          ]),
                          _c(
                            "a",
                            {
                              staticClass: "blue f12 mar10-t",
                              attrs: {
                                href: "https://mp.weixin.qq.com/",
                                target: "_blank"
                              }
                            },
                            [_vm._v("官方注册小程序")]
                          )
                        ]),
                        _c(
                          "div",
                          [
                            _vm.appletInfo == null || _vm.appletInfo.appId == ""
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled: _vm.appletInfo ? true : false
                                    },
                                    on: { click: _vm.queryAuthUrl }
                                  },
                                  [_vm._v("立即授权")]
                                )
                              : _vm._e(),
                            _vm.appletInfo && _vm.appletInfo.appId != ""
                              ? _c("div", { staticClass: "f16" }, [
                                  _c("i", {
                                    staticClass: "el-icon-success mar5-r green"
                                  }),
                                  _c("span", { staticClass: "blue f14" }, [
                                    _vm._v("授权成功")
                                  ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  2
                ),
                _c(
                  "el-step",
                  { staticClass: "f16", attrs: { title: "设置小程序信息" } },
                  [
                    _c("template", { slot: "description" }, [
                      _c("div", { staticClass: "mar30-b flex items-center" }, [
                        _c("div", { staticClass: "pad50-r flex1" }, [
                          _c("p", { staticClass: "gray9 f12 mar10-t" }, [
                            _vm._v(
                              "设置小程序基本信息，生成体验版小程序，查看效果"
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          [
                            _vm.appletInfo == null ||
                            _vm.appletInfo.appId == "" ||
                            (_vm.appletInfo && _vm.appletInfo.auditStatus == 0)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled:
                                        _vm.appletInfo == null ||
                                        _vm.appletInfo.appId == ""
                                    },
                                    on: { click: _vm.openSetVisible }
                                  },
                                  [_vm._v("立即设置")]
                                )
                              : _vm._e(),
                            _vm.appletInfo &&
                            (_vm.appletInfo.auditStatus == 1 ||
                              _vm.appletInfo.auditStatus == 2 ||
                              _vm.appletInfo.auditStatus == 3)
                              ? _c(
                                  "div",
                                  { staticClass: "f16" },
                                  [
                                    _vm.appletInfo.auditStatus == 3
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-success mar5-r green"
                                        })
                                      : _vm._e(),
                                    _vm.appletInfo.auditStatus == 3
                                      ? _c(
                                          "span",
                                          { staticClass: "mar5-r blue f14" },
                                          [_vm._v("设置成功")]
                                        )
                                      : _vm._e(),
                                    _vm.appletInfo.auditStatus == 1
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-warning mar5-r gray9"
                                        })
                                      : _vm._e(),
                                    _vm.appletInfo.auditStatus == 1
                                      ? _c("span", { staticClass: "mar5-r" }, [
                                          _vm._v("立即设置")
                                        ])
                                      : _vm._e(),
                                    _vm.appletInfo &&
                                    _vm.appletInfo.auditStatus == 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "blue f14 flex1 pointer",
                                            on: { click: _vm.openSetVisible }
                                          },
                                          [_vm._v("修改")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mar20-l",
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.appletInfo == null ||
                                            _vm.appletInfo.appId == ""
                                        },
                                        on: { click: _vm.getTestQrcodeUrl }
                                      },
                                      [_vm._v("\n                  获取体验版")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  2
                ),
                _c(
                  "el-step",
                  {
                    staticClass: "f16",
                    attrs: { title: "完成所有准备，提交审核并发布小程序" }
                  },
                  [
                    _c("template", { slot: "description" }, [
                      _c("div", { staticClass: "mar30-b flex items-center" }, [
                        _c("div", { staticClass: "pad50-r flex1" }, [
                          _c("p", { staticClass: "gray9 f12 mar10-t" }, [
                            _vm._v(
                              "提交微信审核（最长14个工作日），审核通过后即可立即发布版本"
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          [
                            _vm.appletInfo == null ||
                            _vm.appletInfo.appId === "" ||
                            (_vm.appletInfo &&
                              _vm.appletInfo.isRelease == 0 &&
                              _vm.appletInfo.auditStatus == 1)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled:
                                        _vm.appletInfo == null ||
                                        (_vm.appletInfo &&
                                          _vm.appletInfo.auditStatus != 1)
                                    },
                                    on: { click: _vm.getSubmit }
                                  },
                                  [_vm._v("提交审核")]
                                )
                              : _vm._e(),
                            _vm.appletInfo &&
                            _vm.appletInfo.isRelease == 0 &&
                            _vm.appletInfo.auditStatus == 2
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", disabled: true },
                                    on: { click: _vm.getSubmit }
                                  },
                                  [_vm._v("审核中")]
                                )
                              : _vm._e(),
                            _vm.appletInfo && _vm.appletInfo.isRelease == 1
                              ? _c("div", { staticClass: "f16" }, [
                                  _c("i", {
                                    staticClass: "el-icon-success mar5-r green"
                                  }),
                                  _c("span", [_vm._v("发布成功")])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            "close-on-click-modal": false,
            visible: _vm.autVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.autVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("img", {
              staticClass: "w200",
              attrs: { src: _vm.authUrl, alt: "" }
            })
          ]),
          _vm.authUrlType == 1
            ? _c("div", { staticClass: "text-center" }, [
                _c("p", [_vm._v("请使用小程序管理员账号扫码授权")])
              ])
            : _vm._e(),
          _vm.authUrlType == 2
            ? _c("div", { staticClass: "text-center" }, [
                _c("p", [_vm._v("温馨提示：请使用小程序主账号扫码体验")])
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.autVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm.authUrlType == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getAppletInfo }
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.authUrlType == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.autVisible = false
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置小程序",
            "close-on-click-modal": false,
            visible: _vm.setVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.setVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "pad20-lr" },
            [
              _c(
                "el-form",
                {
                  ref: "setSubForm",
                  attrs: {
                    model: _vm.setSubForm,
                    rules: _vm.setRules,
                    "label-width": "120px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小程序名称：", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写小程序名称" },
                        model: {
                          value: _vm.setSubForm.title,
                          callback: function($$v) {
                            _vm.$set(_vm.setSubForm, "title", $$v)
                          },
                          expression: "setSubForm.title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分享封面图：", prop: "shareUrl" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "share-uploader",
                          attrs: {
                            action:
                              _vm.env.VUE_APP_fileserver + "persistentUpload",
                            "show-file-list": false,
                            "on-success": _vm.shareSuccess,
                            "before-upload": _vm.uploadBefore
                          }
                        },
                        [
                          _vm.setSubForm.shareImg
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.setSubForm.shareImg }
                              })
                            : _c("i", {
                                staticClass: "el-icon-plus avatar-uploader-icon"
                              })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "登录logo：", prop: "loginUrl" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "share-uploader",
                          attrs: {
                            action:
                              _vm.env.VUE_APP_fileserver + "persistentUpload",
                            "show-file-list": false,
                            "on-success": _vm.shopSuccess,
                            "before-upload": _vm.uploadBefore
                          }
                        },
                        [
                          _vm.setSubForm.shopIcon
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.setSubForm.shopIcon }
                              })
                            : _c("i", {
                                staticClass: "el-icon-plus avatar-uploader-icon"
                              })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "is-required",
                      attrs: { label: "皮肤设置：", prop: "theme" }
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "flex skin-list" },
                        _vm._l(_vm.themeList, function(item) {
                          return _c(
                            "li",
                            {
                              key: item.theme,
                              staticClass: "mar15-r",
                              on: {
                                click: function($event) {
                                  return _vm.changeSkin(item.theme)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "skin pointer relative",
                                  class: item.bgColor
                                },
                                [
                                  _vm.setSubForm.theme === item.theme
                                    ? _c(
                                        "div",
                                        { staticClass: "absolute skin-icon" },
                                        [
                                          _c("img", {
                                            staticClass: "absolute",
                                            attrs: { src: item.icon }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("img", {
                                    staticClass: "absolute skin-example",
                                    attrs: { src: item.example }
                                  })
                                ]
                              ),
                              _c("p", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(item.name))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.setVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.buttonLoading },
                  on: { click: _vm.codeComit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "注册小程序",
            "close-on-click-modal": false,
            visible: _vm.regVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.regVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "pad10_b" },
            [
              _c("el-alert", {
                attrs: {
                  title:
                    "注：信息填写错误导致“代注册提交失败”，请于24小时后重新编辑提交",
                  type: "warning",
                  "show-icon": ""
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pad20-lr" },
            [
              _c(
                "el-form",
                {
                  ref: "setRegForm",
                  attrs: {
                    model: _vm.setRegForm,
                    rules: _vm.regRules,
                    "label-width": "140px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "法人微信号：", prop: "wxName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写法人微信号" },
                        model: {
                          value: _vm.setRegForm.wxName,
                          callback: function($$v) {
                            _vm.$set(_vm.setRegForm, "wxName", $$v)
                          },
                          expression: "setRegForm.wxName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "法人姓名：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写法人姓名" },
                        model: {
                          value: _vm.setRegForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.setRegForm, "name", $$v)
                          },
                          expression: "setRegForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "企业名称：", prop: "orgName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写企业名称" },
                        model: {
                          value: _vm.setRegForm.orgName,
                          callback: function($$v) {
                            _vm.$set(_vm.setRegForm, "orgName", $$v)
                          },
                          expression: "setRegForm.orgName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "代码类型：", prop: "codeType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择活动区域" },
                          model: {
                            value: _vm.setRegForm.codeType,
                            callback: function($$v) {
                              _vm.$set(_vm.setRegForm, "codeType", $$v)
                            },
                            expression: "setRegForm.codeType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "统一社会信用代码", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "组织机构代码", value: 2 }
                          }),
                          _c("el-option", {
                            attrs: { label: "营业执照注册号", value: 3 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "社会信用代码：", prop: "orgCode" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写社会信用代码" },
                        model: {
                          value: _vm.setRegForm.orgCode,
                          callback: function($$v) {
                            _vm.$set(_vm.setRegForm, "orgCode", $$v)
                          },
                          expression: "setRegForm.orgCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服电话：", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写客服电话" },
                        model: {
                          value: _vm.setRegForm.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.setRegForm, "phone", $$v)
                          },
                          expression: "setRegForm.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.regVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      _vm.appletInfo &&
                      (_vm.appletInfo.regStatus == 1 ||
                        _vm.appletInfo.regStatus == 2),
                    loading: _vm.buttonLoading
                  },
                  on: { click: _vm.submitReg }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }